export const MINUTES_LABEL = 'Minutes';
export const SECONDS_LABEL = 'Seconds';
export const PERIOD_LABEL = 'Period';

export enum DIRECTION {
  COLUMN = 'column',
  ROW = 'row',
}
